import React, { useEffect } from "react";
import Layout from "../../components/Layout";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../../contexts/UserContext";
import { useGlobalContext } from "../../contexts/GlobalContext";
import { firstAccessiblePath } from "../../routes/moduleAccess";
import { MOD_ORDER, MOD_SELL_ORDER } from "../../contstants";

const Index = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userData: currentUser, can, canAccessModule, permissionsLoaded } =
    useUserContext();
  const { allowedModules } = useGlobalContext();

  useEffect(() => {
    if (!currentUser?.role) return;

    if (currentUser?.id && !permissionsLoaded) return;

    const reachable = (moduleKey) =>
      allowedModules.includes(moduleKey) &&
      can(moduleKey, "read") &&
      canAccessModule(moduleKey);

    let destination;
    if (reachable(MOD_ORDER)) {
      destination = "/card-issuing/orders";
    } else if (reachable(MOD_SELL_ORDER)) {
      destination = "/card-issuing/sell-orders";
    } else {
      destination = firstAccessiblePath({ allowedModules, can, canAccessModule });
    }

    navigate(destination, { replace: true });
    // eslint-disable-next-line
  }, [currentUser, permissionsLoaded, allowedModules]);

  return (
    <Layout title={t("Card Issuing")} breadcrumbs={t("Card Issuing")}></Layout>
  );
};

export default Index;
